import { api } from '@services';

import { IEquipmentApiModel } from '@models/Equipment.model';
import { IMiscellaneousApiModel } from '@models/Miscellaneous.model';
import { IStudioServiceApiModel } from '@models/StudioService.model';
import { ISoftwareApiModel } from '@models/Software.model';

interface INewEquipment {
  equipmentStatusId?: string;
  statusComment?: string;
}
interface IPatchEquipmentVariables {
  equipmentId?: string;
  softwareId?: string;
  studioServiceId?: string;
  miscellaneousId?: string;
  data: INewEquipment;
}
const patchEquipmentStatus = async ({
  equipmentId,
  softwareId,
  studioServiceId,
  miscellaneousId,
  data,
}: IPatchEquipmentVariables): Promise<
  | IEquipmentApiModel
  | ISoftwareApiModel
  | IStudioServiceApiModel
  | IMiscellaneousApiModel
  | undefined
> => {
  if (equipmentId) {
    const { data: equipment } = await api.patch<IEquipmentApiModel>(
      `/equipments/${equipmentId}`,
      data,
    );
    return equipment;
  }
  if (softwareId) {
    const { data: software } = await api.patch<ISoftwareApiModel>(
      `/software/${softwareId}`,
      data,
    );
    return software;
  }
  if (studioServiceId) {
    const { data: studioService } = await api.patch<IStudioServiceApiModel>(
      `/studioService/${studioServiceId}`,
      data,
    );
    return studioService;
  }
  if (miscellaneousId) {
    const { data: miscellaneous } = await api.patch<IMiscellaneousApiModel>(
      `/miscellaneous/${miscellaneousId}`,
      data,
    );
    return miscellaneous;
  }
  return undefined;
};

export { patchEquipmentStatus };
